import AlertDismissible from '../../Shared/Components/AlertDismissible';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Layout from '../../Shared/Layout/LayoutAdmin';
import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { Inertia } from '@inertiajs/inertia';
import { Link, usePage } from '@inertiajs/inertia-react';
import { hasPermission } from '../../utils/Permissions';

const List = ({ reports, advisers, filters }) => {
    const { flash } = usePage().props;
    const query = new URL(window.location).searchParams;

    const [adviserId, setAdviserId] = useState(filters.adviser || '');
    const [month, setMonth] = useState(filters.month || '');
    const [day, setDay] = useState(filters.day || '');
    const [year, setYear] = useState(filters.year || '');

    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    const currentYear = new Date().getFullYear();

    // Filter the list
    function handleSearch(e) {
        e.preventDefault();

        // Validar año si está presente
        if (year && (isNaN(year) || year < 2020 || year > currentYear)) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `El año debe ser un número válido entre 2020 y ${currentYear}`,
            });
            return;
        }

        Inertia.get(route('commission-reports.index'), {
            adviser: adviserId,
            month: month,
            day: day,
            year: year,
        }, {
            preserveState: true,
            preserveScroll: true,
            replace: true
        });
    }

    function clearFilters() {
        setAdviserId('');
        setMonth('');
        setDay('');
        setYear('');

        Inertia.get(route('commission-reports.index'), {}, {
            preserveState: true,
            preserveScroll: true,
            replace: true
        });
    }

    function handleDelete(report) {
        if (!hasPermission('commission_reports.delete')) {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado',
                text: 'No tienes permisos para eliminar reportes.',
            });
            return;
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción eliminará el reporte de forma permanente",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                Inertia.delete(route('commission-reports.destroy', report.id), {
                    preserveState: true,
                    preserveScroll: true,
                });
            }
        });
    }

    return (
        <Layout>
            <Breadcrumbs texts={['Reportes de Comisiones']} />

            <div className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4 className="card-title">Reportes de Comisiones</h4>
                                {hasPermission('commission_reports.add') && (
                                    <Link
                                        href={route('commission-reports.create')}
                                        className="btn btn-primary"
                                    >
                                        <i className="fa fa-plus"></i> Nuevo Reporte
                                    </Link>
                                )}
                            </div>

                            {flash.success && (
                                <AlertDismissible variant="success" message={flash.success} />
                            )}
                            {flash.error && (
                                <AlertDismissible variant="danger" message={flash.error} />
                            )}

                            {/* Filters */}
                            <Form onSubmit={handleSearch} className="mb-4">
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Asesor</Form.Label>
                                            <Form.Select
                                                value={adviserId}
                                                onChange={(e) => setAdviserId(e.target.value)}
                                            >
                                                <option value="">Todos los asesores</option>
                                                {advisers.map((adviser) => (
                                                    <option key={adviser.id} value={adviser.id}>
                                                        {adviser.user?.name} {adviser.lastname_ap} {adviser.lastname_am}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={1}>
                                        <Form.Group>
                                            <Form.Label>Día</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Día"
                                                min="1"
                                                max="31"
                                                value={day}
                                                onChange={(e) => setDay(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Mes</Form.Label>
                                            <Form.Select
                                                value={month}
                                                onChange={(e) => setMonth(e.target.value)}
                                            >
                                                <option value="">Todos</option>
                                                {months.map((m) => (
                                                    <option key={m} value={m}>{m}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Año</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Ej: 2024"
                                                value={year}
                                                onChange={(e) => setYear(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} className="d-flex align-items-end">
                                        <Button type="submit" variant="primary" className="me-2">
                                            <i className="fa fa-search"></i> Buscar
                                        </Button>
                                        <Button type="button" variant="secondary" onClick={clearFilters}>
                                            Limpiar
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>

                            {/* Table */}
                            <div className="table-responsive">
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Asesor</th>
                                            <th>Día</th>
                                            <th>Mes</th>
                                            <th>Año</th>
                                            <th>Fecha de Carga</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reports.data && reports.data.length > 0 ? (
                                            reports.data.map((report) => (
                                                <tr key={report.id}>
                                                    <td>{report.id}</td>
                                                    <td>
                                                        {report.adviser?.user?.name} {report.adviser?.lastname_ap} {report.adviser?.lastname_am}
                                                    </td>
                                                    <td>{report.day}</td>
                                                    <td>{report.month}</td>

                                                    <td>{report.year}</td>
                                                    <td>
                                                        {new Date(report.created_at).toLocaleDateString('es-MX')}
                                                    </td>
                                                    <td>
                                                        <a
                                                            href={route('commission-reports.download', report.id)}
                                                            className="btn btn-sm btn-info me-1"
                                                            title="Descargar"
                                                        >
                                                            <i className="fa fa-download"></i>
                                                        </a>
                                                        {hasPermission('commission_reports.delete') && (
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={() => handleDelete(report)}
                                                                title="Eliminar"
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    No se encontraron reportes
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Pagination */}
                            {reports.links && reports.links.length > 3 && (
                                <nav className="mt-3">
                                    <ul className="pagination justify-content-center">
                                        {reports.links.map((link, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${link.active ? 'active' : ''} ${!link.url ? 'disabled' : ''}`}
                                            >
                                                {link.url ? (
                                                    <Link
                                                        href={link.url}
                                                        className="page-link"
                                                        preserveState
                                                        preserveScroll
                                                        dangerouslySetInnerHTML={{ __html: link.label }}
                                                    />
                                                ) : (
                                                    <span
                                                        className="page-link"
                                                        dangerouslySetInnerHTML={{ __html: link.label }}
                                                    />
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default List;
